/* eslint-disable import/prefer-default-export */
import { UserInfo } from '@/renderer/types/model/User';
import { create } from 'zustand';
import { useBossProcessStore } from './process';
import { useEffect } from 'react';

interface UseUserStoreType {
  user: UserInfo | null;
  setUser: (user: UserInfo | null) => void;
  onLogout: () => void;
}

export const useUserStore = create<UseUserStoreType>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  onLogout: () => {
    // set({ user: null });
    // window.yqGlobalRouter.router.navigate('/login');
    // ElectronSDK.setStore('Authorization', '');
  },
}));
// TODO: 以上迁移(也无用)

// 初始化所有store 一般是异步获取的数据
export const useStoreInit = () => {
  const { init: initProcess } = useBossProcessStore();

  useEffect(() => {
    initProcess();
  }, [initProcess]);
};
